import React from 'react'
import ShowOrdreTable from '../components/OrdreTable/ShowOrdreTable'

const OrdreTable:React.FC = () => {
  return (<div className='mt-20'>
    <ShowOrdreTable />
  </div>
  )
}

export default OrdreTable